// @flow

import { useSelector } from 'react-redux';
import * as types from '../actionTypes';

const initialState = {
  online: true,
  sessionId: 0,
};

const sessionReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case types.SESSION_ONLINE:
      return {
        ...state,
        online: true,
        sessionId: state.online ? state.sessionId : state.sessionId + 1,
      };
    case types.SESSION_OFFLINE:
      return {
        ...state,
        online: false,
      };
    default:
      return state;
  }
};

export default sessionReducer;

export const selectSession = {
  online: (state: any) => state.session.online,
  sessionId: (state: any) => state.session.sessionId,
};

/* eslint-disable react-hooks/rules-of-hooks */
export const useSession = {
  online: (): boolean => useSelector(state => state.session.online),
  sessionId: (): number => useSelector(state => state.session.sessionId),
};
/* eslint-enable react-hooks/rules-of-hooks */
